import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { clearTypeahed, fetchAllTypeaheadProcessorName } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class ProcessorNameTypeahead extends Component {
    static propTypes = {
        fetchAllTypeaheadProcessorName: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchAllTypeaheadProcessorName(ProcessorNameTypeahead.name);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        let options = [];
        if (this.props.suggestions.length) {
            options = this.props.suggestions.map(proc => ({
                label: proc.name, value: proc.id
            }));
        }

        return (
            <MultiTypeahead
                options={options || []}
                isMulti
                disabled={this.props.disabled}
                required={false}
                isLoading={this.state.isLoading}
                value={this.props.value}
                titleId="processorName"
                animatedPlaceholder={this.props.animatedPlaceholder}
                onChangeSuggestion={this.props.onChangeSuggestion}
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                onFocus={this.onFocus}
                formatOptionLabel={this.props.renderMultiSuggestion}
                error={this.props.error}
                t={this.props.t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === ProcessorNameTypeahead.name
            ? typeahead.list
            : ProcessorNameTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchAllTypeaheadProcessorName,
    clearTypeahed
})(ProcessorNameTypeahead);
